import * as THREE from "three";

export const SKY_COLOR = 0x8fbcd4;

export function createRenderer(canvas: HTMLCanvasElement): THREE.WebGLRenderer {
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setClearColor(SKY_COLOR);
  return renderer;
}

export function createCamera(): THREE.PerspectiveCamera {
  const camera = new THREE.PerspectiveCamera(65, 1, 0.1, 400);
  camera.position.set(0, 6, 12);
  return camera;
}

/**
 * Resizes from the canvas' own layout size each frame instead of a resize
 * listener, so a canvas that starts at zero size (hidden pane, late layout)
 * recovers on its own.
 */
export function syncRendererToCanvas(
  renderer: THREE.WebGLRenderer,
  camera: THREE.PerspectiveCamera,
): void {
  const canvas = renderer.domElement;
  const width = Math.max(1, canvas.clientWidth);
  const height = Math.max(1, canvas.clientHeight);
  if (canvas.width === width && canvas.height === height) return;

  renderer.setSize(width, height, false);
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
}

/**
 * Delta is clamped so returning to a backgrounded tab does not produce one huge
 * simulation step.
 */
export function startRenderLoop(step: (delta: number) => void): () => void {
  const maxDelta = 0.1;
  let last = performance.now();
  let handle = requestAnimationFrame(function frame(now: number) {
    handle = requestAnimationFrame(frame);
    const delta = Math.min((now - last) / 1000, maxDelta);
    last = now;
    step(delta);
  });
  return () => cancelAnimationFrame(handle);
}
